import { isReactNode } from '@/shared/helpers/react'
import classnames from 'classnames'
import React from 'react'
import styles from './AppDescription.module.scss'

type Props = {
  description: string | React.ReactNode;
  centered?: boolean;
  size?: 'xl' | 'md';
}

export function AppDescription({ description, size, centered }: Props) {
  if (isReactNode(description)) {
    return (
      <p className={classnames(styles.text, size === 'xl' && styles.textLg, size === 'md' && styles.textMd, centered && styles.centered)}>
        {description}
      </p>
    )
  }

  return (
    // eslint-disable-next-line react/no-danger
    <p className={classnames(styles.text, size === 'xl' && styles.textLg, size === 'md' && styles.textMd, centered && styles.centered)} dangerouslySetInnerHTML={{ __html: description }} />
  )
}
